import AboutPtBr from 'components/Translate/pt-br/About-pt-br';
import ContactPtBr from 'components/Translate/pt-br/Contact-pt-br';
import FooterPtBr from 'components/Translate/pt-br/Footer-pt-br';
import HeaderPtBr from 'components/Translate/pt-br/Header-pt-br';
import HomePtBr from 'components/Translate/pt-br/Home-pt-br'
import InitialAnimationPtBr from 'components/Translate/pt-br/InitialAnimation-pt-br';
import useIntersectionObserver from 'components/Translate/pt-br/InitialAnimation-pt-br/useIntersectionObserver-pt-br';
import ProjectsPtBr from 'components/Translate/pt-br/Projects-pt-br';
import ScrollToTopPtBr from 'components/Translate/pt-br/Scroll-To-Top-pt-br';
import SkilsPtBr from 'components/Translate/pt-br/Skils-pt-br';
import WarningDarkModePtBr from 'components/Translate/pt-br/WarningDarkMode-pt-br';
import React, { useEffect, useState } from 'react'

export default function SecundaryLaguagePage() {
    
  const [darkMode, setDarkMode] = useState(false);
  const [animationCompleted, setAnimationCompleted] = useState(false);
  const [currentProject, setCurrentProject] = useState(null);

  useEffect(() => {
    if (!animationCompleted) return;
    if (darkMode) {
      document.body.classList.remove('light-mode');
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
      document.body.classList.add('light-mode');
    }
  }, [darkMode, animationCompleted]);
  

  const handleAnimationComplete = () => {
    setAnimationCompleted(true);
  };
  
  useIntersectionObserver(animationCompleted);

    return (
        <main>
            {!animationCompleted ? (
        <InitialAnimationPtBr onAnimationComplete={handleAnimationComplete} />
      ) : (
            <>
                <HeaderPtBr currentProject={currentProject} darkMode={darkMode} setDarkMode={setDarkMode} />
                <ScrollToTopPtBr darkMode={darkMode} />
                <WarningDarkModePtBr setDarkMode={setDarkMode} darkMode={darkMode} />
                <HomePtBr darkMode={darkMode} />
                <AboutPtBr />
                <SkilsPtBr />
                <ProjectsPtBr darkMode={darkMode} currentProject={currentProject} setCurrentProject={setCurrentProject} />
                <ContactPtBr />
                <FooterPtBr />
            </>
            )}
        </main>
      
    )
}
